<!--工程量单位选择弹窗-->
<template>
  <div>
    <el-dialog
      title="选择单位"
      :visible.sync="visible"
      width="800px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose">
      <div class="content">
        <div style="padding: 20px 10px;">请选择单位</div>
        <el-radio-group v-model="curUnit">
          <el-radio border v-for="(item,index) in list" :label="item" :key="index">{{ item }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="flex_jc_center footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button @click="save" type="primary" style="margin-left:20px">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "selectUnit",
  props: {
    visible: {
      type: Boolean
    },
    value: {
      type: String
    }
  },
  data() {
    return {
      list: ["平方米", "立方米", "吨", "米", "寸", "个", "次", "天", "块", "组", "台", "捆", "宗", "项", "株"], // 工程量单位列表
      curUnit: "平方米" // 选中的单位
    }
  },
  watch: {
    visible() {
      this.curUnit = this.value
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 确定单位
    save() {
      this.$emit('update:value', this.curUnit)
      this.handleClose()
    }
  }

}
</script>

<style lang="scss" scoped>
.content {

  .el-radio-group {
    display: flex;
    flex-wrap: wrap;

    .el-radio {
      width: 90px;
      margin: 0 10px 20px;
      height: 34px;
      padding: 9px 20px 0 10px
    }
  }
}


/deep/ .el-dialog__body {
  padding: 0 15px 10px;
}

.bg_gold {
  background: #B79255;
}

.color_fff {
  color: #fff;
}


/deep/ .el-dialog__footer {
  padding-bottom: 40px;
}
/deep/.el-radio.is-bordered.is-checked{
  color: #0286df;
  border-color: #0286df;
  span {
    color: #0286df;
  }
}
.footer {
  .el-button{
    padding: 9px 12px;
  }
}

</style>
